import { ArrowUpRight } from 'lucide-react';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { EXHIBITION_PATH, MY_PROFILE_PATH, PORTFOLIO_PATH, STORE_PATH } from '@/shared/config';

const QUICK_LINKS = [
  { label: '새 디자인 시작', caption: 'Store', to: STORE_PATH },
  { label: '목적별 기획전', caption: 'Exhibition', to: EXHIBITION_PATH },
  { label: '제작 사례 보기', caption: 'Portfolio', to: PORTFOLIO_PATH },
  { label: '회원정보 관리', caption: 'Account', to: MY_PROFILE_PATH },
] as const;

/** 바로가기 — 다음에 할 만한 곳(스토어·기획전·포트폴리오·회원정보)을 얇은 선 칸으로 잇는다. */
export const QuickLinks = (): ReactElement => (
  <nav aria-label="바로가기">
    <ul className="grid grid-cols-2 gap-px border border-foreground/10 bg-foreground/10 lg:grid-cols-4">
      {QUICK_LINKS.map((link) => (
        <li key={link.to}>
          <Link
            to={link.to}
            className="group flex h-full flex-col gap-6 bg-background p-5 transition-colors hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset sm:p-6"
          >
            <span className="flex items-center justify-between">
              <span
                aria-hidden
                className="text-[11px] leading-none font-semibold tracking-[0.18em] text-muted-foreground uppercase"
              >
                {link.caption}
              </span>
              <ArrowUpRight
                aria-hidden
                className="size-4 text-muted-foreground transition-colors group-hover:text-foreground"
                strokeWidth={1.5}
              />
            </span>
            <span className="text-[15px] font-semibold">{link.label}</span>
          </Link>
        </li>
      ))}
    </ul>
  </nav>
);
